import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import interpolate from 'color-interpolate';
import ImageFrameDot from './ImageFrameDot';
import { mod } from '../image_utilities/Math';

const colormap = interpolate(['#477b39', '#a8b69d']);

const ImageFrameDots = ({
  numFrames,
  startIndex,
  imageFrameCount,
  emptyFrameIndices,
  onFrameClick,
  entries,
}) => {
  const getIsKeyframe = (frameIndex) => mod(frameIndex, imageFrameCount) / imageFrameCount === 0;
  const getDotPosition = (index) => `${(index / Math.max(1, numFrames - 1)) * 100}%`;
  const getBackgroundColor = (frameIndex) =>
    colormap(mod(frameIndex, imageFrameCount) / imageFrameCount);

  return (
    <>
      {(entries || Array.from({ length: numFrames })).map((entry, index) => {
        const frameIndex = entry ? entry.frameIndex : mod(index - startIndex, numFrames);
        const trueFrameIndex = entry ? entry.frameIndex : mod(index - startIndex, imageFrameCount);
        // Neighboring hit areas must not cover each other's visible markers.
        const targetSpacing = entry ? Math.min(
          index > 0 ? entry.position - entries[index - 1].position : 100,
          index + 1 < entries.length ? entries[index + 1].position - entry.position : 100
        ) : 100 / Math.max(1, numFrames - 1);
        return (
          <Tooltip
            key={`dot${index + 1}`}
            title={`Edit Frame ${trueFrameIndex + 1}${entry ? ` at ${(entry.time / 1000).toFixed(2)} s` : ''}`}
            enterDelay={0}
            leaveDelay={200}
          >
            <ImageFrameDot
              aria-label={`Edit Frame ${trueFrameIndex + 1}`}
              isKeyframe={getIsKeyframe(frameIndex)}
              isEmpty={emptyFrameIndices.includes(trueFrameIndex)}
              color={getBackgroundColor(frameIndex)}
              position={entry ? `${entry.position}%` : getDotPosition(index)}
              targetSpacing={targetSpacing}
              onClick={() => onFrameClick(trueFrameIndex)}
            />
          </Tooltip>
        );
      })}
    </>
  );
};

ImageFrameDots.propTypes = {
  entries: PropTypes.array,
  numFrames: PropTypes.number.isRequired,
  startIndex: PropTypes.number.isRequired,
  imageFrameCount: PropTypes.number.isRequired,
  emptyFrameIndices: PropTypes.arrayOf(PropTypes.number).isRequired,
  onFrameClick: PropTypes.func.isRequired,
};

export default React.memo(ImageFrameDots);
